import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core'
import { OidcStore } from '@core/store/oidc/oidc.store'
import { Heading } from '@shared/components/heading/heading'

@Component({
  selector: 'bo-callback',
  template: '<bo-heading titleText="MTR_COMMON_LOADING" />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Heading],
})
export class Callback implements OnInit {
  readonly #oidcStore = inject(OidcStore)

  ngOnInit() {
    this.#oidcStore.signInRedirectCallback()
  }
}
